import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/iat.css";
import data from "../ApiUrl/meta_api.js";

import pdfFile3 from "../../assets/pdf/Advanced Industrial Automation Expert.webp";
import pdfFile2 from "../../assets/pdf/Certified Industrial Automation professional.webp";
import pdfFile1 from "../../assets/pdf/Industrial_Automation_Essentials.webp";
import pdfFile from "../../assets/pdf/Industrial_Automation_Quick_Start.webp";
import pdfFile4 from "../../assets/pdf/Professional In Advanced Industrial Automation.webp";
// import apiUrl from "";

// import preloader from "../../assets/images/preloader.gif";

function IndustrialAutomation() {
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopUp, setShowPopUp] = useState(false);

  const [selectedCourse, setSelectedCourse] = useState("beginner");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopUp(true);
    }, 5000);
    return () => clearTimeout(timer); // Cleanup timer if the component is unmounted
  }, []);

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const fetchData = () => {
  const pageMeta = data[0]?.industrial_automation_page;
  if (pageMeta) {
    setMeta(pageMeta);
  }
};


  const handleBeginner = () => setSelectedCourse("beginner");
  const handleIntermediate = () => setSelectedCourse("intermediate");
  const handleAdvance = () => setSelectedCourse("advance");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const Introduction_Automation_Quick_Start = () => {
    setIsCourseData("Industrial Automation Quick start");
    setIsModalOpen(true);
  };

  const Industrial_Automation_Essentials = () => {
    setIsCourseData("Industrial Automation Essentials");
    setIsModalOpen(true);
  };

  const Certified_Industrial_Automation_Professional = () => {
    setIsCourseData("Certified Industrial Automation professional");
    setIsModalOpen(true);
  };

  const Advanced_Industrial_Automation_Expert = () => {
    setIsCourseData("Advanced Industrial Automation Expert");
    setIsModalOpen(true);
  };

  const Professional_In_Advanced_Industrial_Automation = () => {
    setIsCourseData("Professional in Advanced Industrial Automation");
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsCourseData("");
    setIsModalOpen(false);
  };

  const [isCourseData, setIsCourseData] = useState(null); // To store fetched course data

  const [formValues, setFormValues] = useState({
    student_name: "",
    email: "",
    mobile_no: "",
    location: "",
    Prefered_course: "",
    Source_type: "Website",
    Enquiry_date: new Date().toISOString().split("T")[0],
    followups_status: "New",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      Prefered_course: isCourseData ? isCourseData : "", // set the specific field you want to update
    }));

    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "location") {
      if (value === "Others") {
        setShowOtherLocationField(true);
      } else {
        setShowOtherLocationField(false);
      }
    }
  };

  const [errors, setErrors] = useState({});

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [downloadData, setDownloadData] = useState(null); // Store the file info

  const formatTime = () => {
    const currentTime = new Date();
    return currentTime.toLocaleTimeString("en-GB", { hour12: false }); // 24-hour format
  };

  const handleSendMessage = async () => {
    const newErrors = {};

    // Validation logic
    if (!formValues.student_name.trim()) {
      newErrors.student_name = "Name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.student_name)) {
      newErrors.student_name = "Name must contain only letters.";
    }

    if (!formValues.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    if (!formValues.mobile_no.trim()) {
      newErrors.mobile_no = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formValues.mobile_no)) {
      newErrors.mobile_no = "Mobile number must be 10 digits.";
    }

    if (!formValues.location.trim()) {
      newErrors.location = "Location is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.location)) {
      newErrors.location = "Location must contain only letters.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    console.log("Form Values: ", formValues);

    console.log("isLoading before request:", isLoading);
    console.log("isPageDisabled before request:", isPageDisabled);

    setIsLoading(true);
    setIsPageDisabled(true);

    try {
      const response = await axios.post(
        // `${apiUrl}/leads_website`,
        {
          ...formValues,
          fetched_course: isCourseData,
          Enquiry_time: formatTime(), // Only send time
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setFormValues({
        student_name: "",
        email: "",
        mobile_no: "",
        location: "",
        Prefered_course: "",
        Source_type: "Website",
        Enquiry_date: new Date().toISOString().split("T")[0],
        Enquiry_time: "",
        followups_status: "New",
      });

      if (response.status === 200) {
        console.log("Data submitted successfully:", response.data);
        const fileLinks = {
          "Industrial Automation Quick start": pdfFile,
          "Industrial Automation Essentials": pdfFile1,
          "Certified Industrial Automation professional": pdfFile2,
          "Advanced Industrial Automation Expert": pdfFile3,
          "Professional in Advanced Industrial Automation": pdfFile4,
        };

        const selectedFile = fileLinks[isCourseData];
        if (selectedFile) {
          setDownloadData({
            fileUrl: selectedFile,
            fileName: isCourseData.replace(/\s+/g, "_").toLowerCase(),
          });
          setIsModalOpen(false);
          setIsPopupOpen(true); // Show the popup
        } else {
          console.error("No file found for the selected course.");
        }

        // toast.success("Data Sent Successfully!", {
        //   position: "top-center",
        // });
        toast.success("Data Sent Successfully!", {
          position: "top-center",
          autoClose: 2000, // Set timeout for 2 seconds
        });

        setTimeout(() => {
          setIsLoading(false);
          setIsPageDisabled(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred while submitting the data. Please try again.");
      toast.error("Failed to send the Data. Please try again.", {
        position: "top-right",
      });
    } finally {
      // Ensure loader stops after 2 seconds
      setTimeout(() => {
        setIsLoading(false);
        setIsPageDisabled(false);
      }, 2000);
    }
  };

  const handleDownload = () => {
    if (downloadData) {
      const link = document.createElement("a");
      link.href = downloadData.fileUrl;
      link.download = downloadData.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log(`File ${downloadData.fileName} downloaded successfully.`);
      setIsPopupOpen(false); // Close the popup
    }
  };

  const [showOtherLocationField, setShowOtherLocationField] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPageDisabled, setIsPageDisabled] = useState(false);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Service"}</title>
        <link
          rel="canonical"
          href="https://skimitaracademy.com/industrialautomation"
        />
      </Helmet>

      {isLoading && (
        <div className="loader">
          <img
            className=""
            alt=""
            src={require("../../assets/images/SH Logo.webp")}
          ></img>
        </div>
      )}

      <div className={`page-container ${isPageDisabled ? "blurred" : ""}`}>
        <div
          className="backgroundCommenImage mb-5 course_main"
          style={{
            backgroundImage: `url(${require("../../assets/images/Services/IAT/industrialautomation.webp")})`,
            backgroundSize: "cover", // Ensures the image covers the container
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {" "}
          <div className="backgroundcommenImageBannerText"></div>
        </div>

        {/* industrial automation training */}
        <div className="container Pioneers_img  commonmargin ">
          <h1 className="commomtextcolor text-center text-danger">
            {" "}
            Industrial Automation Training
          </h1>
          <div className="row ">
            <div className="col-lg-6 ">
              <div className="row Pioneers_img">
                <div className="col-lg-2 mt-5"></div>
                <div className="col-lg-10 automation-image" data-aos="fade-up">
                  <img
                    className="Pioneerssecond_img"
                    src={require("../../assets/images/Services/IAT/Pros And Cons of AI In Manufacturing.webp")}
                  ></img>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 mt-lg-5 Pioneers_text commonmargin"
              data-aos="fade-right"
            >
              <p className="commonPages">
                Our Industrial Automation Training program is designed to
                provide individuals with the technical expertise needed to excel
                in the rapidly advancing world of automation. This comprehensive
                course covers a wide range of topics, including programmable
                logic controllers (PLC), supervisory control and data
                acquisition (SCADA), robotics, process control, and industrial
                networking. Participants will gain hands-on experience with
                real-world automation systems, learning how to design,
                implement, and maintain automated processes in various
                industries such as manufacturing, energy, and logistics.
              </p>
              <p className="">
                <p className=" commonPages">
                  The program focuses on practical skills, ensuring that
                  trainees are equipped to troubleshoot, optimize, and innovate
                  within automated environments. Additionally, the training
                  incorporates the latest industry trends and best practices,
                  ensuring that participants stay ahead in this dynamic field.
                  Whether you are a beginner looking to start a career in
                  industrial automation or a professional aiming to enhance your
                  skills, this course will empower you to meet the challenges of
                  modern industrial technology, boosting your career prospects
                  and contributing to business success.
                </p>
              </p>
            </div>
          </div>
        </div>

        {/* cutting card section */}
        <h2 className="text-center commomtextcolor margintopdigitalcom text-danger mt-3">
          Why Choose Our Training Program
        </h2>
        <div className="row mt-4">
          <div className="col-lg-12 col-md-12 col-sm-6" data-aos="fade-left">
            <div className="container Expert_led">
              <p className="commonPages">
                Our Industrial Automation Training Program is designed to
                provide in-depth knowledge and practical skills to individuals
                seeking to excel in the growing field of automation. As
                industries across the globe increasingly adopt automation
                technologies, there is a rising demand for skilled professionals
                who can manage and optimize these systems.
              </p>
              <p className="commonPages">
                This program covers all essential aspects of industrial
                automation, including PLC (Programmable Logic Controllers),
                SCADA (Supervisory Control and Data Acquisition), industrial
                robotics, process control, and automation networking. With a
                focus on hands-on training, participants will gain experience in
                troubleshooting, system integration, and process optimization,
                preparing them to tackle real-world challenges in industrial
                settings.
              </p>
              <p className="commonPages">
                Whether you are a beginner starting a career in automation or a
                professional looking to upgrade your skills, our training
                program offers the tools and knowledge to excel in this
                fast-paced, high-demand industry. By the end of the program, you
                will be ready to implement and maintain automated systems that
                enhance productivity, reduce downtime, and improve efficiency.
                Join us to advance your career and become an expert in the
                future of industrial automation.
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div class="row">
            <div class="col-sm-4 col-lg-4 col-md-4 Cutting_Card_Section">
              <div className="card pt-5 cutting_card" data-aos="fade-right">
                <h2 className="Cutting_icons">
                  <i class="fa-solid fa-chalkboard-user"></i>{" "}
                </h2>
                <h3 className="text-danger">Expert Instructors</h3>
                <p className="unlock_card p-3 commonPages">
                  Learn from industry leaders with hands-on experience
                </p>
              </div>
            </div>
            <div class="col-sm-4 col-lg-4 col-md-4 Cutting_Card_Section">
              <div className="card pt-5 cutting_card" data-aos="fade-down">
                <h2 className="Cutting_icons">
                  <i class="fa-solid fa-book-open-reader"></i>{" "}
                </h2>
                <h3 className="text-danger ">Automation Revolution</h3>
                <p className="unlock_card p-3 commonPages">
                  latest in industrial automation technologies
                </p>
              </div>
            </div>
            <div class="col-sm-4 col-lg-4 col-md-4 Cutting_Card_Section">
              <div className="card pt-5 cutting_card" data-aos="fade-left">
                <h2 className="Cutting_icons">
                  <i class="fa-solid fa-award"></i>{" "}
                </h2>
                <h3 className="text-danger">Flexible Learning Options</h3>
                <p className="unlock_card p-3 commonPages">
                  Choose from in-person, online, and hybrid courses
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* cutting card end */}

        {/* Our Training Programs */}

        <div className="container">
          <div className="iatHeading text-center">
            <h2 className="text-danger">Our Training Programs</h2>
            <h4 className="mt-5">
              Explore our diverse range of training programs designed to cater
              to various levels of expertise and industry needs.
            </h4>
          </div>

          <div className="row IATButton ">
            <div className="col-lg-4 Our_Training_Programmes">
              <button
                className={`${
                  selectedCourse === "beginner"
                    ? "btn btn-secondary border border-secondary text-white w-100 rounded-pill IATButton"
                    : "btn btn-white border border-secondary text-secondary w-100 rounded-pill IATButton"
                }`}
                onClick={handleBeginner}
              >
                Beginner Course
              </button>
            </div>
            <div className="col-lg-4 Our_Training_Programmes">
              <button
                className={`${
                  selectedCourse === "intermediate"
                    ? "btn btn-danger border border-danger text-white w-100 rounded-pill IATButton"
                    : "btn btn-white border border-danger text-danger w-100 rounded-pill IATButton"
                }`}
                onClick={handleIntermediate}
              >
                Intermediate Course
              </button>
            </div>
            <div className="col-lg-4 Our_Training_Programmes">
              <button
                className={`${
                  selectedCourse === "advance"
                    ? "btn btn-success border border-success text-white w-100 rounded-pill IATButton"
                    : "btn btn-white border border-success text-success w-100 rounded-pill IATButton"
                }`}
                onClick={handleAdvance}
              >
                Advance Course
              </button>
            </div>
          </div>
          {/* beginner button */}
          {selectedCourse === "beginner" && (
            <div className="mt-5">
              <div className="row" data-aos="fade-up">
                <div className="col-lg-6 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                  <div className="card blogCardSection p-2">
                    <img
                      src={require("../../assets/images/Services/IAT/automationc-1.webp")}
                      className=""
                      alt="Course Image"
                    />
                    <div className="row mt-4 mx-2">
                      <div className="col-lg-12">
                        <p className="blogCardDevelopment ">
                          Industrial Automation
                        </p>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-danger text-center mt-3">
                        Industrial Automation Quick start
                      </h5>
                      <p className="p-2 commonPages">
                        Introduction to Automation explores the principles and
                        technologies used to control and optimize industrial
                        processes with minimal human intervention
                      </p>
                    </div>
                    <div>
                      <div className="row p-2">
                        <div className="col-lg-9 col-md-9 col-sm-12">
                          <p>
                            <i className="fa-solid fa-book"></i> Duration - 1
                            months
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 ">
                          <button
                            className="btn btn-success"
                            style={{
                              cursor: "pointer",
                              fontSize: "12px",
                              textTransform: "none",
                            }}
                            onClick={Introduction_Automation_Quick_Start}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                  <div className="card blogCardSection p-2">
                    <img
                      src={require("../../assets/images/Services/IAT/prog_c-2.webp")}
                      className=""
                      alt="Course Image"
                    />
                    <div className="row mt-4 mx-2">
                      <div className="col-lg-12">
                        <p className="blogCardDevelopment">
                          Industrial Automation
                        </p>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-danger text-center mt-3">
                        Industrial Automation Essentials
                      </h5>
                      <p className="p-2 commonPages">
                        PLC Programming Fundamentals cover the basics of
                        designing and implementing control logic using
                        Programmable Logic Controllers and the Basics.
                      </p>
                    </div>
                    <div>
                      <div className="row p-2">
                        <div className="col-lg-9 col-md-9 col-sm-12">
                          <p>
                            <i className="fa-solid fa-book"></i> Duration - 2
                            months
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12 ">
                          <button
                            className="btn btn-success"
                            style={{
                              cursor: "pointer",
                              fontSize: "12px",
                              textTransform: "none",
                            }}
                            onClick={Industrial_Automation_Essentials}
                          >
                            View Course
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* intermediate button */}

          {selectedCourse === "intermediate" && (
            // <div>Content for Intermediate Course</div>
            <div className="mt-5">
              <div className="row" data-aos="fade-up" >
                <div className="col-lg-12 col-md-12 col-sm-12  ">
                  <div className="row ">
                    <div className="col-lg-6 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                      <div className="card blogCardSection p-2">
                        <img
                          src={require("../../assets/images/Services/IAT/adv_plc_c4.webp")}
                          className=""
                          alt="Course Image"
                        />
                        <div className="row mt-4 mx-2">
                          <div className="col-lg-12">
                            <p className="blogCardDevelopment">
                              Industrial Automation
                            </p>
                          </div>
                        </div>
                        <div>
                          <h5 className="text-danger text-center mt-3">
                            Certified Industrial Automation professional
                          </h5>
                          <p className="p-2 commonPages">
                            Advanced PLC Programming involves developing complex
                            control logic for programmable logic controllers to
                            handle sophisticated automation tasks.
                          </p>
                        </div>
                        <div>
                          <div className="row p-2">
                            <div className="col-lg-9 col-md-9 col-sm-12">
                              <p>
                                <i className="fa-solid fa-book"></i> Duration -
                                3 months
                              </p>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12">
                              <button
                                className="btn btn-success"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  textTransform: "none",
                                }}
                                onClick={
                                  Certified_Industrial_Automation_Professional
                                }
                              >
                                View Course
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                      <div className="card blogCardSection p-2">
                        <img
                          src={require("../../assets/images/Services/IAT/sca_da_data_acq_c5.webp")}
                          className=""
                          alt="Course Image"
                        />
                        <div className="row mt-4 mx-2">
                          <div className="col-lg-12">
                            <p className="blogCardDevelopment">
                              Industrial Automation
                            </p>
                          </div>
                        </div>
                        <div>
                          <h5 className="text-danger text-center mt-3">
                            Advanced Industrial Automation Expert
                          </h5>
                          <p className="p-2 commonPages">
                            SCADA Systems and Data Acquisition involve
                            monitoring and controlling industrial processes
                            through real-time data collection and analysis
                            today.
                          </p>
                        </div>
                        <div>
                          <div className="row p-2">
                            <div className="col-lg-9 col-md-9 col-sm-12">
                              <p>
                                <i className="fa-solid fa-book"></i> Duration -
                                6 months
                              </p>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 ">
                              <button
                                className="btn btn-success"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  textTransform: "none",
                                }}
                                onClick={Advanced_Industrial_Automation_Expert}
                              >
                                View Course
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* advance button */}

          {selectedCourse === "advance" && (
            <div className="mt-5">
              <div className="row" data-aos="fade-up">
                <div className="col-lg-12 col-md-12 col-sm-12  ">
                  <div className="row">
                    <div className="col-lg-6 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                      <div className="card blogCardSection p-2">
                        <img
                          src={require("../../assets/images/Services/IAT/c7.webp")}
                          className=""
                          alt="Course Image"
                        />
                        <div className="row mt-4 mx-2">
                          <div className="col-lg-12">
                            <p className="blogCardDevelopment">
                              Industrial Automation
                            </p>
                          </div>
                        </div>
                        <div>
                          <h5 className="text-danger text-center mt-3">
                            Professional In Advanced Industrial Automation
                          </h5>
                          <p className="p-2 commonPages">
                            Industrial Networking and the Communication involve
                            in the integration of various network technologies
                            to enable seamless data exchange
                          </p>
                        </div>
                        <div>
                          <div className="row p-2">
                            <div className="col-lg-9 col-md-9 col-sm-12">
                              <p>
                                <i className="fa-solid fa-book"></i> Duration -
                                9 months
                              </p>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 ">
                              <button
                                className="btn btn-success"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "12px",
                                  textTransform: "none",
                                }}
                                onClick={
                                  Professional_In_Advanced_Industrial_Automation
                                }
                              >
                                View Course
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* how to begin your automation value */}

        <div className="commonmargin">
          <div className="container begin_your_automation">
            <div className="row align-items-center">
              <div className="col-lg-6 order-2 order-lg-1" data-aos="fade-right">
                <h3 className=" Journey text-center text-danger commomtextcolor">
                  How to Begin Your Automation Journey
                </h3>

                <div className="row mt-5 align-items-start">
                  <div className="col-2 col-lg-2 text-center">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-industry mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-10 col-lg-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Assess Your Needs :
                      </span>
                      Identify the specific requirements and goals for
                      implementing automation in your environment
                    </h6>
                  </div>
                </div>
                <div className="row mt-5 align-items-start">
                  <div className="col-2 col-lg-2 text-center">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-arrow-up-right-from-square mx-4"></i>
                    </h2>
                  </div>
                  <div className="col-lg-10 col-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Choose the Right Training :
                      </span>
                      Select from our courses that cover foundational to
                      advanced automation technologies
                    </h6>
                  </div>
                </div>
                <div className="row mt-5 align-items-start">
                  <div className="col-lg-2 col-2 text-center">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-chart-line mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-lg-10 col-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Gain Practical Experience :
                      </span>{" "}
                      Engage in hands-on training to apply theoretical knowledge
                      in real-world scenarios
                    </h6>
                  </div>
                </div>
                <div className="row mt-5 align-items-start">
                  <div className="col-lg-2 col-2 text-center">
                    <h2 className="Automation_icons">
                      <i class="fa-solid fa-building-columns mx-4"></i>{" "}
                    </h2>
                  </div>
                  <div className="col-lg-10 col-10">
                    <h6 className="Assess_content">
                      <span className="Assess text-danger">
                        Stay Updated :
                      </span>{" "}
                      Continuous learning is key to keeping up with advancements
                      in automation technologies
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mt-5 order-1 order-lg-2">
                <div className="row align-items-top">
                  <div className="col-lg-8 col-12" data-aos="fade-up">
                    <div className="Automation mt-3 text-center">
                      <img
                        className="automation_img "
                        src={require("../../assets/images/Services/IAT/how to begin 2.webp")}
                      ></img>
                    </div>
                  </div>
                  <div className="col-lg-4 d-none d-lg-block Automation_Journey_YellowColor">
                    <div className="bg-danger Automation_card"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Our Certified Partners! */}

        {/* Our Trainings */}
        <div className="our-training-section">
          <h2 className="training-title text-danger">Our Trainings</h2>

          <div className="container">
            <div className="row justify-content-center align-items-center training-logos">
              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/100013.png")}
                  alt="Mitsubishi"
                />
              </div>

              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/schneider.webp")}
                  alt="Schneider"
                />
              </div>

              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/10005.webp")}
                  alt="Siemens"
                />
              </div>

              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/rock.webp")}
                  alt="Rockwell"
                />
              </div>

              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/25.webp")}
                  alt="Delta"
                />
              </div>

              <div className="col-lg-2 col-md-4 col-6 text-center">
                <img
                  src={require("../../assets/images/Services/IAT/11.webp")}
                  alt="Omron"
                />
              </div>
            </div>
          </div>
        </div>

        {/* modal code start */}

        {isModalOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span className="close text-danger text-end" onClick={closeModal}>
                &times;
              </span>
              <h2>Course Details</h2>
              <form>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="student_name"
                      name="student_name"
                      value={formValues.student_name}
                      onChange={handleChange}
                      required
                    />
                    <label>Name</label>
                    {errors.student_name && (
                      <div className="text-danger">{errors.student_name}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      id="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      required
                    />
                    <label>Email</label>
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="tel"
                      placeholder=""
                      id="mobile_no"
                      name="mobile_no"
                      value={formValues.mobile_no}
                      onChange={handleChange}
                      required
                    />
                    <label>Mobile</label>
                    {errors.mobile_no && (
                      <div className="text-danger">{errors.mobile_no}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <select
                      id="location"
                      name="location"
                      className="form-select"
                      value={formValues.location}
                      onChange={handleChange}
                    >
                      <option value="">Select Location</option>
                      <option value="Salem">Salem</option>
                      <option value="Erode">Erode</option>
                      <option value="Others">Others</option>
                    </select>
                    {errors.location && (
                      <div className="text-danger">{errors.location}</div>
                    )}
                  </div>

                  {showOtherLocationField && (
                    <div className="mb-3">
                      <input
                        type="text"
                        id="other_location"
                        name="other_location"
                        className="form-control"
                        placeholder="Enter Your Location"
                        value={formValues.other_location || ""}
                        onChange={handleChange}
                      />
                      {errors.location && (
                        <div className="text-danger">{errors.location}</div>
                      )}
                    </div>
                  )}

                  <div className="floating-label">
                    <input
                      type="text"
                      className="form-control"
                      name="Prefered_course"
                      value={isCourseData || formValues.Prefered_course || ""}
                      disabled
                    />
                    <label>Preferred Course</label>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <p
                        className="btn btn-success"
                        onClick={handleSendMessage}
                      >
                        Send
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        {isPopupOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span
                className="close text-danger text-end"
                onClick={() => setIsPopupOpen(false)}
              >
                &times;
              </span>
              <h2>Download File</h2>

              <p>Click the button below to download the file:</p>
              <button className="btn btn-success" onClick={handleDownload}>
                Download
              </button>
            </div>
          </div>
        )}

        <ToastContainer />

        {/* modal code end */}
      </div>
    </>
  );
}

export default IndustrialAutomation;
